import { Store, User, ProfileData } from '../../models/user'
import { UserAction } from '../../models/userAction'
import { AppState, UserState } from '../states'
import { LocalStorage } from '../../utils/localstorage'
import { UserApi } from '../../api/userApi'
import { UserPermissions } from '../../models/permissions'
import { UserHelper, UserHelperEvents } from '../../utils/userHelper'
import {
    store360URL,
    wholesaleURL,
    smartlyURL,
} from '../../Techedge-digitalportal-shared'
import { Analytics } from '../../utils/analytics'
import { loadFilterList } from './filters'
import deDEDictionary from './../../utils/localization/assets/dictionaries/de-DE.json'
import enUsDictionary from './../../utils/localization/assets/dictionaries/en-UK.json'
import esESDictionary from './../../utils/localization/assets/dictionaries/es-ES.json'
import frFRDictionary from './../../utils/localization/assets/dictionaries/fr-FR.json'
import itItDictionary from './../../utils/localization/assets/dictionaries/it-IT.json'
import jaJPDictionary from './../../utils/localization/assets/dictionaries/ja-JP.json'
import ptPTDictionary from './../../utils/localization/assets/dictionaries/pt-PT.json'
import ptBRDictionary from './../../utils/localization/assets/dictionaries/pt-BR.json'
import trTRDictionary from './../../utils/localization/assets/dictionaries/tr-TR.json'
import zhCNDictionary from './../../utils/localization/assets/dictionaries/zh-CN.json'
import zhHKDictionary from './../../utils/localization/assets/dictionaries/zh-HK.json'
import thTHDictionary from './../../utils/localization/assets/dictionaries/th-TH.json'
import plPLDictionary from './../../utils/localization/assets/dictionaries/pl-PL.json'
import csCzDictionary from './../../utils/localization/assets/dictionaries/cs-CZ.json'
import huHUDictionary from './../../utils/localization/assets/dictionaries/hu-HU.json'
import nlNLDictionary from './../../utils/localization/assets/dictionaries/nl-NL.json'
import svSEDictionary from './../../utils/localization/assets/dictionaries/sv-SE.json'

export const setAccessToken = (accessToken: string, mode?: any) => {
    return (dispatch: any, getState: any) => {
        LocalStorage._shared().setAccessToken(accessToken)
        dispatch(
            UserAction.UserToken({
                accessToken: accessToken,
                loading: mode && mode === 'standalone',
            })
        )
    }
}

export const setPortal = (code: string) => {
    return (dispatch: any, getState: any) => {
        LocalStorage._shared().setPortal(code)
        dispatch(UserAction.UserPortal(code))
    }
}

export const loggedIn = (
    accessToken: string,
    refreshToken: string,
    mode?: any
) => {
    return async (dispatch: any, getState: any) => {
        let state: AppState = getState() as AppState
        let userState: UserState = (getState() as AppState).userReducer

        if (userState.loading) {
            return
        }
        dispatch(UserAction.UserRequest())

        if (accessToken && state.userReducer.accessToken !== accessToken) {
            dispatch(setAccessToken(accessToken, mode))
        } else {
            if (mode !== 'standalone') {
                let user: User = UserHelper._shared().user()
                dispatch(getEnabledApps(false, user))
                if (!window.location.pathname.includes('notifications'))
                    UserHelper._shared().goToDefaultApp()
                if (window.location.origin + '/' === process.env.SMARTLY_URL)
                    loadFilterList(true)
                if (userState.user.name) return
            }
        }

        dispatch(UserAction.UserRequest())
        try {
            const userData: ProfileData = (await UserApi.ProfileInfo())
                .data as ProfileData
            // const user: User = (await UserApi.WhoAmI()).data.user as User
            const user: User = userData.user
            user.nickname = userData.nickname
            let store: Store = {} as Store
            try {
                store = (await UserApi.getUserStore()).data.store as Store
            } catch (error) {}
            user.store = store

            const _lang = userData.language
            let dictionary
            switch (_lang) {
                case 'de':
                case 'de-DE':
                    dictionary = deDEDictionary
                    break
                case 'en':
                case 'en-US':
                case 'en-UK':
                    dictionary = enUsDictionary
                    break
                case 'es':
                case 'es-ES':
                    dictionary = esESDictionary
                    break
                case 'fr':
                case 'fr-FR':
                    dictionary = frFRDictionary
                    break
                case 'it':
                case 'it-IT':
                    dictionary = itItDictionary
                    break
                case 'ja':
                case 'ja-JP':
                    dictionary = jaJPDictionary
                    break
                case 'pt':
                case 'pt-PT':
                    dictionary = ptPTDictionary
                    break
                case 'pt-BR':
                    dictionary = ptBRDictionary
                    break
                case 'tr':
                case 'tr-TR':
                    dictionary = trTRDictionary
                    break
                case 'zh-CN':
                    dictionary = zhCNDictionary
                    break
                case 'zh-HK':
                    dictionary = zhHKDictionary
                    break
                case 'th-TH':
                    dictionary = thTHDictionary
                    break
                default:
                    dictionary = enUsDictionary
                    break
            }
            user.language = _lang || 'en-US'
            user.dictionary = dictionary
            user.profilePicURL = userData.attachment?.url
            const payload: UserState = {
                ...userState,
                user,
                accessToken,
                refreshToken,
                i18n: userState.i18n,
                isAdminSocialHub: userData.isAdminSocialHub,
            } as UserState
            LocalStorage._shared().setPersistentData(payload)
            dispatch(UserAction.UserSuccess(payload))
            if (mode === 'standalone') {
                return
            }
            dispatch(getEnabledApps(true, user))
            Analytics._sendAnalyticsLinkEvent(
                'Account',
                'Login',
                'Static',
                user
            )
        } catch (error) {
            // dispatch(UserAction.UserError(error));
            // LocalStorage._shared().setPersistentData({} as UserState);

            dispatch(UserAction.UserError(error))
        }
    }
}

export const getProfileInfo = () => {
    return async (dispatch: any, getState: any) => {
        dispatch(UserAction.ProfileInfoRequest())
        let state: AppState = getState() as AppState
        let userState: UserState = state.userReducer
        try {
            const userData: ProfileData = (await UserApi.ProfileInfo())
                .data as ProfileData
            const _lang = userData.language
            let dictionary
            switch (_lang) {
                case 'de':
                case 'de-DE':
                    dictionary = deDEDictionary
                    break
                case 'en':
                case 'en-US':
                case 'en-UK':
                    dictionary = enUsDictionary
                    break
                case 'es':
                case 'es-ES':
                    dictionary = esESDictionary
                    break
                case 'fr':
                case 'fr-FR':
                    dictionary = frFRDictionary
                    break
                case 'it':
                case 'it-IT':
                    dictionary = itItDictionary
                    break
                case 'ja':
                case 'ja-JP':
                    dictionary = jaJPDictionary
                    break
                case 'pt':
                case 'pt-PT':
                    dictionary = ptPTDictionary
                    break
                case 'pt-BR':
                    dictionary = ptBRDictionary
                    break
                case 'tr':
                case 'tr-TR':
                    dictionary = trTRDictionary
                    break
                case 'zh-CN':
                    dictionary = zhCNDictionary
                    break
                case 'zh-HK':
                    dictionary = zhHKDictionary
                    break
                case 'th-TH':
                    dictionary = thTHDictionary
                    break
                case 'cs-CZ':
                    dictionary = csCzDictionary
                    break
                case 'hu-HU':
                    dictionary = huHUDictionary
                    break
                case 'nl-NL':
                    dictionary = nlNLDictionary
                    break
                case 'pl-PL':
                    dictionary = plPLDictionary
                    break
                case 'sv-SE':
                    dictionary = svSEDictionary
                    break
                default:
                    dictionary = enUsDictionary
                    break
            }
            const payload: UserState = {
                ...userState,
                user: {
                    ...userState.user,
                    language: _lang || 'en-US',
                    dictionary: dictionary,
                    profilePicURL: userData.attachment?.url,
                },
                isAdminSocialHub: userData.isAdminSocialHub,
            } as UserState
            // save in User State
            dispatch(UserAction.UserSuccess(payload))
            LocalStorage._shared().setPersistentData(payload)
        } catch (error) {
            // dispatch(UserAction.UserError(error));
            // LocalStorage._shared().setPersistentData({} as UserState);

            dispatch(UserAction.UserError(error))
        }
    }
}

export const getEnabledApps = (fromLogin?: boolean, user?: any) => {
    return async (dispatch: any, getState: any) => {
        dispatch(UserAction.UserRequest())
        try {
            const permissions: UserPermissions = (
                await UserApi.GetEnabledApps()
            ).data as UserPermissions
            LocalStorage._shared().setPermissions(permissions)
            dispatch(UserAction.UserPermissionsSuccess(permissions))

            if (
                fromLogin &&
                !window.location.pathname.includes('notifications')
            ) {
                UserHelper._shared().goToDefaultApp()
            }

            // Moved getSmartlyPermission to smart-home-fe in App.tsx to fix performance issue
            // if (user) {
            //     // console.log('SELECTED PORTAL', 'SMARTLY')
            //     UserHelper._shared().getSmartlyPermissions(user)
            // }
        } catch (error) {
            dispatch(UserAction.UserError(error))
            // const permissions: UserPermissions = new UserPermissions();
            // LocalStorage._shared().setPermissions(permissions);
            // dispatch(UserAction.UserPermissionsSuccess(permissions));
        }
    }
}

export const logout = () => {
    return (dispatch: any, getState: any) => {
        if ((getState() as any).userReducer.loading) {
            return
        }
        dispatch(UserAction.UserRequest())
        UserApi.Logout(UserHelper._shared().accessToken()).finally(() => {
            // window.addEventListener('beforeunload', beforeUnloadCallback)
            localStorage.clear()
            let event = window.document.createEvent('UIEvents')
            event.initEvent(UserHelperEvents.LOGOUT, true, false)
            window.dispatchEvent(event)
            sessionStorage.clear()

            const domains = [store360URL, wholesaleURL, smartlyURL]

            let count = {}

            domains.forEach((d) => {
                let iframe = document.createElement('iframe')
                iframe.onload = function () {
                    iframe.contentWindow.postMessage('clear-local-storage', d)
                    count[d] = true
                    if (
                        count[smartlyURL] &&
                        count[wholesaleURL] &&
                        count[store360URL]
                    ) {
                        localStorage.clear()
                        Analytics._sendAnalyticsLinkEvent(
                            'Account',
                            'Logout',
                            'Static'
                        )

                        dispatch(UserAction.UserLogout())
                    }
                } // before setting 'src'
                const path: string = d.endsWith('/') ? 'iframe' : '/iframe'
                iframe.src = d + path + '?win=iframe'
                iframe.style.display = 'none'
                document.body.appendChild(iframe)
            })
        })

        // const iframeList = document.getElementsByTagName('iframe')
        // if (iframeList.length > 0) {
        //     // send messages to other roots to clear their local storages
        //     document
        //         .getElementsByTagName('iframe')[0]
        //         .contentWindow.postMessage('clear-local-storage', store360URL)
        //     document
        //         .getElementsByTagName('iframe')[1]
        //         .contentWindow.postMessage('clear-local-storage', wholesaleURL)
        //     document
        //         .getElementsByTagName('iframe')[2]
        //         .contentWindow.postMessage('clear-local-storage', smartlyURL)
        // }

        if (process.env.REACT_APP_ENV === 'development') {
            localStorage.setItem('devtools', 'true')
        }
    }
}

export const switchLocale = (locale: string) => {
    return (dispatch: any, getState: any) => {
        dispatch(UserAction.UserSwitchLocaleSuccess(locale))
    }
}
